export default __webpack_public_path__ + "static/media/commerce.2b5661af.svg";